import {atom} from "jotai";

export const ChatDrawerAtom = atom({
  open: false,
  startNode: null
})

export const ConfirmDialogAtom = atom({
  open: false,
  title: "",
  message: "",
})

// Backs useCallConfirm/CallConfirmDialogModal — a separate atom from ConfirmDialogAtom so the
// phone-style call-confirmation UI never collides with the generic yes/no confirm dialog.
export const CallConfirmDialogAtom = atom({
  open: false,
  title: "",
  subtitle: "",
})

export const DialAtom = atom(false);

// Backs the Start node's Web Call / Phone Call flow (StartCallModal) — mirrors ChatDrawerAtom's
// shape but for the two AMI-dialplan-driven channels instead of the chatbot drawer.
export const StartCallAtom = atom({
  open: false,
  mode: null, // "web" | "phone"
});

// Map of registry projectId -> {token, expiresAt} unlock sessions for message protection.
// See useFlowProtection hook.
export const FlowProtectionSessionsAtom = atom({});